import styled from 'styled-components'

export const AlgoliaPaginationItem = styled.div`
  font-size: ${({ theme }) => theme.rem(18)};

  &:not(:last-child) {
    margin-right: ${({ theme }) => theme.rem(8)};
  }
`

export const AlgoliaPagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`